// src/components/PublicRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const PublicRoute = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    // Se o cara já está logado, não faz sentido ver Login/Cadastro
    // Mandamos ele para a raiz (que mostrará a Dashboard)
    return <Navigate to="/" replace />;
  }

  // Se não estiver logado, permite ver a página (Login, Cadastro, etc)
  return <Outlet />;
};

export default PublicRoute;
